import { mapActions } from "vuex";

export default  {
	created () {    
	   
	},
	methods: 
    {	
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				let savePost = false
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						
						case 'guardarFtn':	
							const await8 = this.updateDataForm({ state: 'afiliado_beneficiarios/name', data:  this.dataForm[this.namePath].afiliado_inclusiones.name})
							const await9 = this.updateDataForm({ state: 'afiliado_beneficiarios/id_datos_afiliado', data: this.searchSw.value})
							const await10 = this.updateDataForm({ state: 'afiliado_inclusiones/id_datos_afiliado', data: this.searchSw.value})
							const await11 = this.updateDataForm({ state: 'afiliado_inclusiones/id_info_afiliacion', data:  this.searchsGet.id})

							if(this.dataForm[this.namePath].afiliado_inclusiones.direccion==='')
							{
								await this.updateDataForm({ state: 'afiliado_inclusiones/direccion', data: this.swSearchs.datos_afiliado.direccion})
							}
							// configurar dataPost
							if(event.save===false)
							{
								
								await this.updateDataPost({ state: 'data', data:  []})
							}							
							const await12 = this.updateDataPost({ state: 'route', data:   'save_all'})
							const await13 = this.updateDataPost({ state: 'tablaPost', data:  ['afiliado_beneficiarios','afiliado_inclusiones','subir_archivos']})
							const await14 = this.updateDataPost({ state: 'tablaDelete', data:  []})
							await Promise.all([await9,await9,await10,await11,await12,await13,await14])
						break;	
						case 'tablePostGuardarFtn': 
							savePost=true
						break;
						case 'radicadoInclusionFtn': 							
							const await20 = this.updateDataPost({ state: 'data', data:  []})
							const await21 = this.updateDataPost({ state: 'route', data:   'save_all'})
							const await22 = this.updateDataPost({ state: 'tablaPost', data:  ['afiliado_inclusiones','subir_archivos']})
							const await23 = this.updateDataPost({ state: 'tablaDelete', data:  []})
							await Promise.all([await20,await21,await22,await23])
						break;
						case 'anularInclusionFtn': 		
							const await24 = this.updateDataPost({ state: 'data', data:  []})
							const await25 = this.updateDataPost({ state: 'route', data:   'save_all'}) 
							const await27 = this.updateDataPost({ state: 'tablaPost', data:  ['afiliado_beneficiarios','afiliado_inclusiones']})
							const await28 = this.updateDataPost({ state: 'tablaDelete', data:  ['afiliado_beneficiarios','afiliado_inclusiones']})
							await Promise.all([await24,await25,await27,await28])
						break;
					}
				}

				await this.save(event.save,savePost)

				if(event.save===false)
				{
					await this.resetCrud({state: 'searchSw'})
				}				
				if(this.active===1)
				{
					await this.getDataGet({route: 'get_inclusionespend', data: 'clientes'})
				}
				if(this.active===2)
				{
					await this.getDataGet({route: 'get_inclusioneshist', data: 'clientes'})
				}
					await this.resetDataPost({state: 'data'}) 
				const await30 =  this.resetFile()				
				const await31 =  this.resetDataIndex()
				const await32 =  this.resetGlobal({state: 'openModal'})
				const await33 =  this.resetDataForm()
				const await34 =  this.resetGlobal({state: 'saveConfig/capa'}) 
				await Promise.all(await30,await31,await32,await33,await34)
			}
			catch{

			}			
		}		
	},
}
